import React from 'react';

interface Props {
  value: number | string; // Numeric or string input
  className?: string; // Optional CSS class for styling
  decimalScale?: number; // Number of decimal places
  fixedDecimalScale?: boolean; // Whether to enforce fixed decimal places
  thousandSeparator?: string; // Separator for thousands
  decimalSeparator?: string; // Separator for decimals
  prefix?: string; // Optional prefix to display, e.g., ' €'
  suffix?: string; // Optional suffix to display, e.g., ' EUR'
  onValueChange?: (value: string) => void; // Callback for input changes
}

class BelfiusCurrencyText extends React.Component<Props> {
  formatCurrency = (value: number | string): string => {
    const {
      decimalScale = 2,
      fixedDecimalScale = true,
      thousandSeparator = '.',
      decimalSeparator = ',',
    } = this.props;

    // Parse value to a float number
    let numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numericValue)) {
      numericValue = 0; // Fallback to 0 if value cannot be parsed
    }

    // Create a formatter using Intl.NumberFormat
    const formatter = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: fixedDecimalScale ? decimalScale : 0,
      maximumFractionDigits: decimalScale,
    });

    // Format the value
    let formattedValue = formatter.format(numericValue);

    // Replace separators if custom separators are provided
    if (thousandSeparator !== '.' || decimalSeparator !== ',') {
      formattedValue = formattedValue
        .replace(/\./g, thousandSeparator)
        .replace(/,/g, decimalSeparator);
    }

    return formattedValue;
  };

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { onValueChange, prefix = '', suffix = '' } = this.props;
    const rawValue = event.target.value;

    // Remove prefix, suffix, and separators to extract the numeric part
    const cleanedValue = rawValue
      .replace(prefix, '') // Remove the prefix
      .replace(suffix, '') // Remove the suffix
      .replace(/[^\d.,-]/g, ''); // Remove any non-numeric characters

    // Trigger callback if provided
    if (onValueChange) {
      onValueChange(cleanedValue);
    }
  };

  render() {
    const { value, prefix = '', suffix = '' } = this.props;
    const formattedValue = `${prefix}${this.formatCurrency(value)}${suffix}`;

    return (
      <div>
        <span>
          {formattedValue}
        </span>
      </div>
      // <input
      //   type="text"
      //   className={className}
      //   value={formattedValue}
      //   onChange={this.handleInputChange} // Handle user input
      // />
    );
  }
}

export default BelfiusCurrencyText;
